<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.16"
    height="12"
    viewBox="0 0 11.16 12"
  >
    <path
      d="M5.49,15H7.564l1.089-3.069H13.5L14.576,15H16.65L12.141,3H10Zm3.789-4.809,1.74-4.963h.1l1.74,4.963Z"
      transform="translate(-5.49 -3)"
    />
  </svg>
</template>

<script>
export default {
  name: 'FontIcon',
};
</script>
